import React, { FC } from 'react';

import SelectorForm from './components/SelectorForm';
import { NodeProps } from 'src/presentation/components/pages/ivr/constants/ivrConstants';

const VoicemailNode: FC<NodeProps> = props => {
  return <SelectorForm nodeProps={props} saveConfirmationTitle={'Saving Voicemail Node'} />;
};

export default VoicemailNode;
